import React, { useCallback, useEffect } from 'react';
import {
  LogoImage,
  FormBox,
  TitleSection,
  ResetButton,
  ResetContainer,
  ResetTitle,
  ResetWraper,
  ResetPhrase,
  InputContainer,
  LogoWrapper
} from './styles';
import viewPassword from '../../../assets/viewPassword.svg';
import logoImage from '../../../assets/soji_logo.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPasswordValidation } from '../validation';
import { useFormik } from 'formik';
import {
  useEditResetPasswordMutation,
  useValidateTokenMutation
} from '../../../store/auth/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { Loader } from '../../../component/loader';

const InputNewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userToken = location.search.replace('?token=', '');
  const [validateToken, { isLoading: isValidationLoading }] =
    useValidateTokenMutation();
  const [resetPassword, { isLoading: isResetLoading }] =
    useEditResetPasswordMutation();

  const handleValidateToken = useCallback(() => {
    validateToken({ token: userToken })
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
      })
      .catch((err) => {
        showErrorToast(err.message);
        navigate('/password-reset');
      });
  }, [validateToken, userToken, navigate]);
  useEffect(() => {
    handleValidateToken();
  }, [handleValidateToken]);

  const handleReset = (values: { token: string; newPassword: string }) => {
    const payload = { token: values.token, newPassword: values.newPassword };
    resetPassword(payload)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        navigate('/', { replace: true });
      })
      .catch((err) => {
        showErrorToast(err.message);
      });
  };
  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: { token: userToken, newPassword: '', confirmPassword: '' },
    validationSchema: resetPasswordValidation,
    onSubmit: handleReset
  });

  return (
    <ResetWraper>
      <LogoWrapper>
        <LogoImage src={logoImage} alt="logo" />
      </LogoWrapper>
      {isValidationLoading ? (
        <Loader />
      ) : (
        <>
          <ResetContainer>
            <FormBox onSubmit={handleSubmit}>
              <TitleSection>
                <ResetTitle>Reset password</ResetTitle>
              </TitleSection>
              <ResetPhrase>Create new password.</ResetPhrase>
              <InputContainer
                labelText={'Create Password'}
                value={values.newPassword}
                onChange={handleChange('newPassword')}
                errorMessage={touched.newPassword ? errors.newPassword : ''}
                placeholder={'Create Password'}
                type={'password'}
                icon={viewPassword}
              />
              <InputContainer
                labelText={'Confirm Password'}
                value={values.confirmPassword}
                onChange={handleChange('confirmPassword')}
                errorMessage={
                  touched.confirmPassword ? errors.confirmPassword : ''
                }
                placeholder={'Confirm Password'}
                type={'password'}
                icon={viewPassword}
              />
              <ResetButton
                isLoading={isResetLoading}
                type={'submit'}
                buttonText={'Proceed'}
              />
            </FormBox>
          </ResetContainer>
        </>
      )}
    </ResetWraper>
  );
};

export default InputNewPassword;
